<template>
    <div :class="{'container': !containerless, 'contents': containerless}">
        <div
            class="view-h2"
            :class="{
                'col-start-1 col-span-full md:col-start-2 md:col-end-12 lg:!col-start-3 lg:col-end-11': containerless,
                '!col-start-3 col-span-8': !containerless
            }"
        >{{content?.value[mainStore.active_locale]}}</div>
    </div>
</template>

<script lang="ts" setup>
import type { LocalizedText } from "#layers/cms/shared/types/bucketData"

const mainStore = useMainStore()

const {content} = defineProps({
    content: Object as PropType<{value: LocalizedText}>,
    containerless: {
        type: Boolean,
        default: false
    }
})
</script>